<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'

const props = withDefaults(
  defineProps<{
    isDense?: boolean
    paddingToIgnore?: number
    class?: string | string[]
  }>(),
  {
    class: '',
    isDense: false,
    paddingToIgnore: 0
  }
)
</script>

<template>
  <div
    class="border-b"
    :class="[
      twMerge('border-b border-uiPrimary-200', props.class),
      {
        'pb-6': !props.isDense,
        'pb-4': props.isDense
      }
    ]"
    :style="{
      width: `calc(100% + ${paddingToIgnore * 2}px)`,
      'margin-left': `-${paddingToIgnore}px`
    }"
  />
</template>
